export const carouselTranslations = {
	en: {
		goToSlide: 'Go to slide {slideNumber}',
		previousSlide: 'Previous slide',
		nextSlide: 'Next slide',
	},
	sk: {
		goToSlide: 'Prejsť na snímku {slideNumber}',
		previousSlide: 'Predchádzajúca snímka',
		nextSlide: 'Ďalšia snímka',
	},
	cs: {
		goToSlide: 'Přejít na snímek {slideNumber}',
		previousSlide: 'Předchozí snímek',
		nextSlide: 'Další snímek',
	},
	de: {
		goToSlide: 'Zu Folie {slideNumber} gehen',
		previousSlide: 'Vorherige Folie',
		nextSlide: 'Nächste Folie',
	},
	hu: {
		goToSlide: 'Ugrás a(z) {slideNumber}. diára',
		previousSlide: 'Előző dia',
		nextSlide: 'Következő dia',
	},
};

export const getTranslation = (language, key, params = {}) => {
	const translations = carouselTranslations[language] || carouselTranslations.en;
	let text = translations[key] || carouselTranslations.en[key];

	// Replace placeholders like {slideNumber}
	Object.keys(params).forEach((param) => {
		text = text.replace(`{${param}}`, params[param]);
	});

	return text;
};
